import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Roles, password } from '../models/roles.model';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RolesService {

  constructor(
    private _http: HttpClient
  ) { }

  addUsers(role: Roles): Observable<any> {
    return this._http.post('user/add/', role);
  }

  getUsers(status:any, search:any, page: number, rowsPerPage: number, sortBy?:string): Observable<any> {
    let params = new HttpParams();
    params = params.set('status', status);
    if (search) {
      params = params.set('search', search);
    }
    if (sortBy) {
      params = params.set('sort_by', sortBy);
    }
    params = params.set('page', page.toString());
    return this._http.get('user/invited-list/', {params});
  }

  updateUser(role: Roles, id:number): Observable<any> {
    return this._http.patch('user/update-data/' + id + '/', role);
  }
  removeUser(id:any) : Observable<any> {
  return this._http.patch('user/revoke/', {user_id: id});
  }
  restoreAccess(id:any) : Observable<any> {
    return this._http.post('user/re-send/',{id:id})
  }
  reactivateAccess(id:any) : Observable<any> {
    return this._http.patch('user/restore/',{user_id:id})
  }
  archiveUser(id:any, is_archived:boolean) : Observable<any> {
    return this._http.patch('user/archive/',{user_id:id, is_archived:is_archived})
  }
  uploadImage(imageFile: File, id :any,  file_type:any): any {

    const formData: FormData = new FormData();
    formData.append('photo', imageFile, imageFile.name);
    formData.append('file_type', file_type);

    return this._http.put('user/upload-photo/' + id + '/', formData);
  }
  getUserDetail(id:any):any{
    return this._http.get('user/get-details/' + id + '/' )
  }
  deleteUserProfile(id:any):any{
    return this._http.delete('user/remove-image/' + id + '/' )
  }
  changePassword(password:password , id:any){
    return this._http.put('user/reset-password/' , password)
  }
  private userImageSource = new Subject<string>();
  userImage$ = this.userImageSource.asObservable();

  updateUserImage(image: string) {
    this.userImageSource.next(image);
  }
}
